var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNtDollarMark = function SvgNtDollarMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgNtDollarMark",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgNtDollarMark{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    transform: "translate(-777 -243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    transform: "translate(777.003 243.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    className: "svgNtDollarMark svgBase svgHover svgSelect",
    d: "M0.8,13.4c-0.3,0-0.5-0.2-0.5-0.5V5.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v7.8 C1.3,13.2,1.1,13.4,0.8,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    className: "svgNtDollarMark svgBase svgHover svgSelect",
    d: "M7.7,13.4c-0.3,0-0.5-0.2-0.5-0.5V5.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v7.8 C8.2,13.2,7.9,13.4,7.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    className: "svgNtDollarMark svgBase svgHover svgSelect",
    d: "M17.2,5.6h-5.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5.9c0.3,0,0.5,0.2,0.5,0.5 C17.7,5.4,17.5,5.6,17.2,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    className: "svgNtDollarMark svgBase svgHover svgSelect",
    d: "M14.2,13.4c-0.3,0-0.5-0.2-0.5-0.5V5.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v7.8 C14.7,13.2,14.5,13.4,14.2,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    className: "svgNtDollarMark svgBase svgHover svgSelect",
    d: "M7.7,13.4c-0.1,0-0.3-0.1-0.4-0.2L0.4,5.4c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0 L8,12.5c0.2,0.2,0.2,0.5,0,0.7C7.9,13.3,7.8,13.4,7.7,13.4z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNtDollarMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nt_dollar_mark.985be990.svg";
export { ForwardRef as ReactComponent };